import React from 'react'
import { css } from 'glamor'
import PlexiLogo from '../../images/plexi-logo-new.svg'
import Dropdown from '../global/Dropdown'
import { Link } from "gatsby"
import DownChevron from '../../images/DownChevron.svg'
import { legalMenuItems } from '../../constants/menuItems'


class LegalHeader extends React.Component {
	constructor(props) {
		super(props);

		this.renderTrigger = this.renderTrigger.bind(this);
	}

	renderTrigger() {
		return (
			<div {...css({
				display: "flex",
				justifyContent: "space-between",
				width: "300px",
			})}>
				<div {...css({ lineHeight: '32px', cursor: "pointer" })}>{this.props.pageTitle}</div>
				<img src={DownChevron} alt={"dropdown chevron"} />
			</div>
		)
	}


	render() {
		return (
			<div
				{...css({
					position: 'fixed',
					background: 'white',
					display: 'flex',
					height: '76px',
					padding: '20px 0 20px 30px',
					width: '100%',
					zIndex: 10,
					borderBottom: '1px solid #f5f5f5',
				})}
			>
				<Link to="/">
					<img
						{...css({
							float: 'left',
							width: 51.5,
							height: 25,
							margin: '4px 0',
							backgroundImage: `url(${PlexiLogo})`,
						})}
						src={PlexiLogo}
						alt='Plexi Logo'
					/>
				</Link>
				<div {...css({ padding: "0 16px" })}>
					<Dropdown triggerValue={this.props.pageTitle} options={legalMenuItems} />
				</div>
			</div>
		)
	}
}

export default LegalHeader
